import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { getGeoJSON } from '../GeoJSON/MapCommonFunctions';
import { Divider, Menu, MenuItem, Typography } from '@mui/material';
import './GeoHelp.css';
import CloseIcon from '@mui/icons-material/Close';
import { Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';
import { useDispatch } from 'react-redux';

const GoeHelp = ({
  //props
  propKey,
  anchorElement,
  open,
  mapJSON,
  handleClose,

  //state
  chartControls,
  chartProperties,
}: any) => {
  let geoLocation = chartProperties.properties[propKey].Geo.geoLocation;
  let type = chartProperties.properties[propKey].Geo.geoMapKey;

  const [keys, setKeys] = useState<string[]>([]);

  const Dispatch = useDispatch();

  useEffect(() => {
    (async () => {
      let tempKeys = Object.keys(mapJSON?.features[0].properties || {}).filter((item) =>
        ['continent', 'hc-a2', 'iso-a2', 'iso-a3', 'region-wb', 'subregion'].includes(item),
      );
      tempKeys.sort();

      if (geoLocation.includes('Cities')) {
        tempKeys = ['city'];
      } else tempKeys = ['name', ...tempKeys];

      setKeys(tempKeys);
    })();
  }, [mapJSON, geoLocation]);

  const columnWidth = 8.1;
  const tableWidth = `${keys.length * columnWidth}rem`;

  return (
    <div>
      <Menu
        id="basic-menu"
        className="geoHelpTable"
        anchorEl={anchorElement}
        open={open}
        onClose={(event, reason) => {
          if (reason === 'backdropClick') return;
          handleClose();
        }}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
          disablePadding: true,
          style: {
            display: 'flex',
            flexDirection: 'column',
            height: '100%',
            overflowX: 'auto',
            overflowY: 'hidden',
          },
        }}
        PaperProps={{
          style: {
            maxHeight: '34rem',
            overflow: 'hidden',
            display: 'flex',
            flexDirection: 'column',
          },
        }}
      >
        <div
          style={{
            display: 'flex',
            width: keys.length === 1 ? '15rem' : tableWidth,
            background: '#fff',
            padding: '5px 0',
            flexShrink: 0,
            borderBottom: '1px solid lightgray',
          }}
        >
          <Typography
            style={{
              textAlign: 'left',
              justifyContent: 'center',
              marginLeft: '1%',
            }}
          >
            The Table shows the available keys in the selected map
            <span style={{ fontWeight: 'bold' }}> {geoLocation}. </span> Based on your location
            information select the appropriate key
          </Typography>

          <CloseIcon
            onClick={handleClose}
            sx={{
              fontSize: 'large',
              color: '#545454',
              cursor: 'pointer',
              '&:hover': {
                color: 'red',
              },
              marginLeft: 'auto',
              marginRight: '0px',
              justifyContent: 'center',
            }}
          />
        </div>
        <div style={{ overflowY: 'auto', overflowX: 'hidden', flex: 1, width: '100%' }}>
          <Table stickyHeader style={{ tableLayout: 'fixed', width: tableWidth }}>
            <TableHead>
              <TableRow>
                {keys.map((hdr: any, idx: number) => {
                  return (
                    <TableCell
                      style={{
                        fontWeight: 'bold',
                        backgroundColor: '#AF99DB',
                        color: '#ffffff',
                        textTransform: 'uppercase',
                        width: keys.length === 1 ? '15rem' : `${columnWidth}rem`,
                      }}
                      key={idx}
                    >
                      {hdr}
                    </TableCell>
                  );
                })}
              </TableRow>
            </TableHead>
            <TableBody style={{ width: 'auto' }}>
              {mapJSON?.features
                ?.filter((item: any) => {
                  //filter empty cells
                  return keys.some((hdr: any) => {
                    const val = item.properties[hdr];
                    return val !== null && val !== undefined && val !== '';
                  });
                }) // sorting
                ?.sort((a: any, b: any) => {
                  const key = 'city';
                  const valA = (a.properties[key] ?? '').toString().toLowerCase();
                  const valB = (b.properties[key] ?? '').toString().toLowerCase();
                  return valA.localeCompare(valB);
                })
                .map((item: any, index: number) => {
                  return (
                    <TableRow key={index} id="TRow">
                      {keys.map((hdr: any, idx: number) => {
                        return (
                          <TableCell
                            key={idx}
                            id="TColumn"
                            sx={{
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                            }}
                            title={item.properties[hdr]}
                          >
                            {item.properties[hdr]}
                          </TableCell>
                        );
                      })}
                    </TableRow>
                  );
                })}
            </TableBody>
          </Table>
        </div>
      </Menu>
    </div>
  );
};

const mapStateToProps = (state: any) => {
  return {
    chartControls: state.chartControls,
    chartProperties: state.chartProperties,
  };
};

export default connect(mapStateToProps, null)(GoeHelp);
